/**
 * Created: 2026-04-07
 * Initial commit: Add formatEventTimeRange date utility
 *
 * Shared date formatting utilities for the frontend.
 */

import { addHours, format } from 'date-fns'
import { zhCN } from 'date-fns/locale'

export { getWeekdayText } from '@tc-app/shared/booking/getWeekdayText'

/**
 * Format a start time and duration into a human-readable range string.
 * Example: '2026-04-14 周二 15:00-16:00'
 */
export function formatEventTimeRange(
  startTime: string | Date,
  duration: number,
): string {
  const start = new Date(startTime)
  const end = addHours(start, duration)
  return `${format(start, 'yyyy-MM-dd EEE HH:mm', { locale: zhCN })}-${format(end, 'HH:mm')}`
}
